import * as React from "react";
import PropTypes from "prop-types";
import Backbone from "backbone";
import CommonControlWrapper from "nexia_mobile/components/Controls/wrappers/CommonControlWrapper";
import DeviceControlButton from "nexia_mobile/components/Controls/DeviceControlButton";

const Valve = ({ model, isDetailed, showSpinner, hideSpinner }) => (
  <CommonControlWrapper isDetailed={isDetailed}>
    <DeviceControlButton
      alert={model.isValveClosed()}
      buttonLabel={model.isValveClosed() ? "Open" : "Close"}
      disabled={!model.isValveOperable()}
      onTap={() => {
        showSpinner(
          `${model.isValveClosed() ? "Opening" : "Closing"} '${model.get(
            "name"
          )}'`
        );
        model.operateValve().then(hideSpinner, hideSpinner);
      }}
    />
  </CommonControlWrapper>
);
Valve.propTypes = {
  model: PropTypes.instanceOf(Backbone.Model).isRequired,
  isDetailed: PropTypes.bool.isRequired,
  showSpinner: PropTypes.func.isRequired, // (?string) => void
  hideSpinner: PropTypes.func.isRequired, // () => void
};

export default Valve;



// WEBPACK FOOTER //
// ./src/components/Controls/Valve.jsx